import React, { Component } from 'react';
import classNames from 'classnames';
import './index.css';

// images
import uncheckedUrl from './off.svg';
import checkedUrl from './on.svg';
import checkedDisabledUrl from './on-disabled.svg';

export const CHECKED_CLASS = 'is-checked';

class Checkbox extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isChecked: props.isChecked || false,
    };
  }

  componentWillReceiveProps(nextProps) {
    const { isChecked, isEnabled } = nextProps;

    if (!isEnabled) return;

    const { value } = this.state;
    if (isChecked !== value) {
      this.setState({ isChecked });
    }
  }

  toggleCheckbox = () => {
    const { isChecked } = this.state;
    const { onToggle } = this.props;

    this.setState({ isChecked: !isChecked });

    if (onToggle) {
      onToggle(!isChecked);
    }
  };

  render() {
    const { children, isEnabled } = this.props;
    const { isChecked } = this.state;

    const className = isEnabled ? 'Checkbox' : 'Checkbox-disabled';

    return (
      <div
        className={classNames(className, { [CHECKED_CLASS]: isChecked })}
        onClick={this.toggleCheckbox}
      >
        <div className="Checkbox-inputWrapper">
          {isEnabled ? <EnabledImage /> : <DisabledImage />}
        </div>
        <div className="Checkbox-label">{children}</div>
      </div>
    );
  }
}

function EnabledImage() {
  return (
    <div className="Checkbox-input">
      <img
        id="unchecked_image"
        className="Checkbox-square Checkbox-square--unchecked"
        src={uncheckedUrl}
        alt="checkbox checked"
      />
      <img
        id="checked_image"
        className="Checkbox-square Checkbox-square--checked"
        src={checkedUrl}
        alt="checkbox checked"
      />
    </div>
  );
}

function DisabledImage() {
  return (
    <div className="Checkbox-input">
      <img
        id="checked_disabled_image"
        className="Checkbox-square Checkbox-square--checked-disabled"
        src={checkedDisabledUrl}
        alt="checkbox checked disabled"
      />
    </div>
  );
}

export default Checkbox;



// WEBPACK FOOTER //
// ../ui-components/components/Checkbox/index.jsx